
import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/pages/Home";
import Contact from "./components/pages/Contact";
import Hotelpinewood from "./components/pages/Hotelpinewood";
import Services from "./components/pages/Services";
import Eidmenu from "./components/pages/Eidmenu";
import Footer from "./components/inc/Footer";
import Bpage from './components/pages/Bpage';
import Pinewoodpage from './components/pages/Pinewoodpage';
import Roofpage from './components/pages/Roofpage';
import About from './components/pages/About';
function App() {
  return (
    <>
      <BrowserRouter>
        {/* <Header/> */}

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/Hotelpinewood" element={<Hotelpinewood />} />
          <Route path="/services" element={<Services />} />
          <Route path="/menu" element={<Eidmenu />} />

          <Route path="/Berhampore-lodge" element={<Bpage />} />
          <Route path="/Hotel-Pinewood" element={<Pinewoodpage />} />
          <Route path="/rooftop-restraurant" element={<Roofpage />} />
                    <Route path="/about-us" element={<About/>} />
        </Routes>



        <Footer />

      </BrowserRouter>
    </>
  );
}

export default App;
